import { Button, Classes, H5, HTMLTable, Popover } from "@blueprintjs/core";
import {
  MDBBtn,
  MDBCol,
  MDBRow,
} from "mdbreact";
import { observer } from "mobx-react";
import * as React from "react";
import { api_adm } from "../../api";
import { INotaVar } from "../../model";
import { AppStore } from "../../stores/AppStore";
import { NotaVarStore } from "../../stores/vars/NotaVarStore";
import { toast } from "react-toastify";
import { sortBy } from "../../utils";

interface NotaVarsPageProps {
}

interface NotaVarsPageState {
}

@observer
export class NotaVarsPage
  extends React.Component<NotaVarsPageProps, NotaVarsPageState>
{
  componentDidMount() {
    AppStore.setTitle("Variáveis Pará");
    NotaVarStore.load();
  }

  handleCreate = () => {
    AppStore.setLocation("/var/create");
  };

  handleEdit(v: INotaVar) {
    AppStore.setLocation(`/var/edit/${v.id}`);
  }

  async handleDelete(v: INotaVar) {
    try {
      let resp = await api_adm.delete(`/api/admin/nota_vars/${v.id}`);
      if (resp.data.ok) {
        toast.success(`Variável excluída: ${v.nome}`, {});
        NotaVarStore.load();
      } else {
        toast.error(`Erro excluindo variável: ${resp.data.msg}`, {});
      }
    } catch (ex) {
      toast.error('Erro excluindo Variável!', {});
    }
  }

  render() {
    let sorted = sortBy(NotaVarStore.obs.vars, "nome");
    let items = sorted?.map(v => {
      return (
        <tr key={v.id} className="nz-table-actions">
          <td>{v.nome}</td>
          <td>{v.descricao}</td>
          <td>
            <MDBBtn
              color="default"
              rounded
              size="sm"
              onClick={this.handleEdit.bind(this, v)}
            >
              <img src="/images/edit.png" width={25} />
            </MDBBtn>
            <Popover popoverClassName={Classes.POPOVER_CONTENT_SIZING}>
              <MDBBtn color="default" rounded size="sm">
                <img src="/images/bin.png" width={25} />
              </MDBBtn>
              <div>
                <H5>Confirmar exclusão?</H5>
                <p>Confirmar exclusão da variável {v.nome}?</p>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    marginTop: 15,
                  }}
                >
                  <Button
                    className={Classes.POPOVER_DISMISS}
                    style={{ marginRight: 10 }}
                  >
                    Cancelar
                  </Button>
                  <Button
                    intent="danger"
                    className={Classes.POPOVER_DISMISS}
                    onClick={this.handleDelete.bind(this, v)}
                  >
                    Excluir
                  </Button>
                </div>
              </div>
            </Popover>
          </td>
        </tr>
      );
    });

    return (
      <div>
        <MDBRow>
          <MDBCol md="3">
            <MDBBtn className="btnDefault noFloat" onClick={this.handleCreate}>
              Criar Variável
            </MDBBtn>
          </MDBCol>
        </MDBRow>
        <div className="TableDefault">
          <HTMLTable
            className="table table-hover dataTable"
            style={{ width: "100%" }}
            small
          >
            <thead>
              <tr>
                <th style={{ width: 220 }}>Nome</th>
                <th>Descrição</th>
                <th style={{ width: 120 }} />
              </tr>
            </thead>
            <tbody>
              {items}
            </tbody>
          </HTMLTable>
        </div>
        <div style={{ marginBottom: 80 }} />
      </div>
    );
  }
}

export default NotaVarsPage;
